import Vue from 'vue'
const loadstatus = {
	state: {
	    loadState: false,
	    loadCount: 0,
			login:[],
			ifEditVoucer:false,	//true  当前凭证是否已修改
			voucherEdit:false,  //true  修改凭证   false 其他
			auxliaryModal:false, //true  当前是否存在辅助核算
			moneyOtherEach:false,
			moneyOtherEach1:false,
			isEditVoucerChange: false,  // 是否关闭凭证标签
			voucherData:'', //当期凭证数据
			isClickCache: false,  // 判断用户点击导航栏还是菜单
			requestHttp: true,
			superPreventOperationState: false,
      rejectProblemCount: 1, // 进入首页自动弹出问题弹窗
	  },
	  mutations: {
		    LOADSTATECHANGE: (state,bol) => {
		      if (bol) {
		        state.loadCount++;
		      } else {
		        state.loadCount--;
		        if (state.loadCount <= 0) {
		          state.loadState = bol;  
		        }
		        return false;
		      }
		      state.loadState = bol;
		    },
		    SUPERPREVENTFUNCTION(state,bol) {  // 阻止用户操作
		    	state.superPreventOperationState = bol;
		    },
		    UPDATAVOUCHER_SUPER(state,bol) {  // 判断用户是否关闭了新增凭证标签
		    	state.isEditVoucerChange = bol;
		    },
		    REQUEXTHTTP_ONE(state,bol) {  // 判断用户是否关闭了新增凭证标签
		    	state.requestHttp = bol;
		    },
			UPDATELOGIN(state,bol){
				state.login =bol; 
			},
			UPDATAVOUCHER(state,bol){  //判断用户是否修改了凭证内容
				state.ifEditVoucer = bol;
			},
			UPDATAVOUCHEREDIT(state,bol){  //添加判断是否在进行修改or查看凭证
				state.voucherEdit = bol
			},
			UPDATEAUXLIARY(state,bol){  //判断 辅助核算呵呵
				state.auxliaryModal = bol
			},
			UPDATEAMONEYEACH(state,bol){  //是否进行相互运算  --- 当在数量核算时不进行相互运算
				state.moneyOtherEach = bol
			},
			UPDATEAMONEYEACH1(state,bol){  //是否进行相互运算  --- 当在数量核算时不进行相互运算
				state.moneyOtherEach1 = bol
			},
			SAVELOCALVOUCHER(state,obj){
				state.voucherData = obj;
			},
			ISCLICKCACHE(state,bol) {
				state.isClickCache = bol;
			},
      SET_PROBLEM_COUNT(state){
        state.rejectProblemCount++
      }
	   },
	   actions: {
	   		
	   }
}

export default loadstatus


// WEBPACK FOOTER //
// ./src/store/modules/loadingState.js